import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Button as AntButton, Form as AntForm, Space } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import '../../Styles/StyleHome.css';
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import SocieteAdminPanel, { Societe } from './SocieteAdminPanel';

import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export type MfaActionMode = 'view' | 'add' | 'edit';

interface SocietePageProps { isAdmin?: boolean; }

export default function SocietePage({ isAdmin }: SocietePageProps) {
  const auth = useAuthUser();
  const currentUser: any = auth();


  const [actionMode, setActionMode] = useState<MfaActionMode>('view');
  const [saveRequest, setSaveRequest] = useState(0);
  const [deleteRequest, setDeleteRequest] = useState(0);
  const [consultRequest, setConsultRequest] = useState(0);
  const [selectedSociete, setSelectedSociete] = useState<Societe | null>(null);
  const [form] = AntForm.useForm();

  const isEditing = actionMode !== 'view';
  const resetAction = () => setActionMode('view');
  const editSelection = () => setActionMode('edit');
  const cancelAction = () => {
    form.resetFields();
    setSelectedSociete(null);
    setActionMode('view');
  };

  const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': { backgroundColor: emphasize(backgroundColor, 0.06) },
    '&:active': { boxShadow: theme.shadows[1], backgroundColor: emphasize(backgroundColor, 0.12) },
  };
}) as typeof Chip;

  // if (!effectiveIsAdmin) {
  //   return (
  //     <div className="tab">
  //       <Alert severity="info" sx={{ mt: 2 }}>
  //         L'accès à la gestion des sociétés est réservé à l'administrateur.
  //       </Alert>
  //     </div>
  //   );
  // }

  return (
  <div className="tab">
    <Box className="formTitle">
      <Breadcrumbs aria-label="breadcrumb">
        <StyledBreadcrumb component="a" href="/jjh" label="Home" icon={<HomeIcon fontSize="small" />} />
        <StyledBreadcrumb component="a" href="#" label="Gestion" />
        <StyledBreadcrumb label="GESTION DE SOCIÉTÉ" deleteIcon={<ExpandMoreIcon />} />
      </Breadcrumbs>
    </Box>
    {/* Conteneur flex : formulaire à gauche (flex-grow), actions à droite (largeur fixe) */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        width: '100%',
      }}
    >
      <div className="clientP" style={{ flex: 1, minWidth: 0 }}>
        <Box sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          mb: 2,
          backgroundColor: 'var(--primaryColor)',
          color: 'var(--white)',
          padding: '8px 16px',
          borderRadius: 1,
          borderBottom: '5px solid var(--darkColor)',
          whiteSpace: 'nowrap',
        }}>
          <BankOutlined style={{ color: 'var(--white)' }} />
          <Typography fontWeight={600} sx={{ color: 'var(--white)' }}>Gestion des sociétés</Typography>
        </Box>
        <SocieteAdminPanel
          mode={actionMode}
          saveRequest={saveRequest}
          deleteRequest={deleteRequest}
          consultRequest={consultRequest}
          onSaved={resetAction}
          selectedSociete={selectedSociete}
          onSelectSociete={setSelectedSociete}
          searchForm={form}
        />
      </div>

      <div
        className="bG"
        style={{
          flex: '0 0 220px',
          width: 220,
          position: 'relative',
          left: 'auto',
          top: 'auto',
          marginTop: 72,
          boxSizing: 'border-box',
        }}
      >
        <legend><Typography color="darkgreen">Actions</Typography></legend>
        <Space direction="vertical" style={{ width: '100%' }}>
          <AntButton
            size="large" className="bt_add" type="ghost" htmlType="button" block
            disabled={isEditing}
            onClick={() => {
              setActionMode('view');
              setConsultRequest((v) => v + 1);
            }}
          >
            Consulter
          </AntButton>
          <AntButton
            size="large" className="bt_add" type="ghost" htmlType="button" block
            disabled={actionMode === 'add'}
            onClick={() => setActionMode('add')}
          >
            Ajouter
          </AntButton>
          <AntButton
            size="large" className="bt_add" type="ghost" htmlType="button" block
            disabled={actionMode === 'edit' || !selectedSociete}
            onClick={editSelection}
          >
            Modifier
          </AntButton>
          <AntButton
            size="large" className="bt_add" type="ghost" htmlType="button" block
            disabled={!isEditing}
            onClick={() => setSaveRequest((value) => value + 1)}
          >
            Enregistrer
          </AntButton>
          <AntButton
            size="large" className="bt_add" type="ghost" htmlType="button" block
            disabled={!selectedSociete}
            onClick={() => setDeleteRequest((value) => value + 1)}
          >
            Supprimer
          </AntButton>
          <AntButton
            size="large" className="bt_add" type="ghost" htmlType="button" block
            disabled={!isEditing && !selectedSociete}
            onClick={cancelAction}
          >
            Annuler
          </AntButton>
        </Space>
      </div>
    </Box>
  </div>
);
}
